import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { IFRFitxa } from './fitxes.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FitxesService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(codi, lang): Observable<IFRFitxa> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<IFRFitxa>(this._API_BASE_URL + 'fitxa/'+codi+'/lang/'+lang, this.options)
    .pipe(map(response => {
      return response || null;
    }));
  }

  public update(data): Observable<any> {
    return this.authHttp.put(this._API_BASE_URL + 'fitxa/'+data.codi+'/lang/'+data.idioma, data)
      .pipe(map(response => response || {}));
  }
  
  constructor(private authHttp: HttpClient) { }
}
